// extracted by mini-css-extract-plugin
export default {"headBox":"about_headBox__NpSHQ","imageBox":"about_imageBox__rqrz-","titleBox":"about_titleBox__uOpIe","presentationWrap":"about_presentationWrap__2v7NC"};